export default __webpack_public_path__ + "static/media/logo-1.db8a8445.svg";